import { Injectable } from '@angular/core';
import { DefaultService, ApuType, BaseResponseDTO } from '@psnb/psnb-api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PowerSupplyAputypesService {

  constructor(private powerSupplyService: DefaultService) { 
    this.getAllApuTypesFromService();
  }

  getAllApuTypesFromService() {
    return this.powerSupplyService.getAllApuTypes().pipe(map(result => result));
  }

  createApuType(apuType: ApuType) {
    return this.powerSupplyService.createApuType(apuType).pipe(map(result => result));
  }

  deleteApuType(id: number): Observable<BaseResponseDTO> {
    return this.powerSupplyService.deleteApuType(id).pipe(map(result => result));
  }

  updateApuType(apuType: ApuType) {
    return this.powerSupplyService.updateApuType(apuType).pipe(map(result => result));
  }
}
